import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'countries';

var cacheCountryList = null;

const CountryService = {
  getList() {
    if (cacheCountryList !== null) {
      return new Promise((resolve) => {
        resolve({
          data: cacheCountryList
        });
      });
    }

    return new Promise(async (resolve) => {
      const {data} = await Http.get(`/${RESOURCE_NAME}`);

      cacheCountryList = data;

      resolve({
        data: data
      });
    });
  },
  getListByStudent() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
};

export default CountryService;
